import {
  Box,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { dateformat } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import { FechaField } from '../../../accesos/components/FechaField';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  allBloquesPedagogicosAction,
  oneBloquesPedagogicosAction,
} from '../../bloques_pedagogicos/BloquesPedagogicosAction';
import { saveBlopedFechasAction } from '../BlopedFechasAction';

const FormBlopedFechas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const blopedFechasStore = Redux.useSelector((state) => state.blopedFechas);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );

  const activo = blopedFechasStore.activo;

  const initData = {
    desde: dateformat(null, {}),
    hasta: dateformat(null, {}),
    activo: false,
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    desde: false,
    hasta: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveBlopedFechasAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
          idBloquePedagogico: bloquesPedagogicosStore.activo.id,
        },
        blopedFechasStore.params,
      );
      if (res) {
        await allBloquesPedagogicosAction(dispatch, entidadesStore.params);
        await oneBloquesPedagogicosAction(
          dispatch,
          bloquesPedagogicosStore.activo.id,
        );
        setOpenModalForm(false);
      }
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <FechaField
            views={['year', 'month', 'day']}
            openTo="month"
            botonCurrentDate={false}
            label={CONST.desde.name}
            value={data.desde}
            error={dataError.desde}
            onChange={(e) =>
              _handleSetDataField(CONST.desde.name, dateformat(e, {}))
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FechaField
            views={['year', 'month', 'day']}
            openTo="month"
            botonCurrentDate={false}
            label={CONST.hasta.name}
            value={data.hasta}
            error={dataError.hasta}
            onChange={(e) =>
              _handleSetDataField(CONST.hasta.name, dateformat(e, {}))
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="small" required error={dataError.activo}>
            <InputLabel id={`label_${CONST.activo.name}`}>
              Activar fecha
            </InputLabel>
            <Select
              id={CONST.activo.name}
              value={data.activo}
              required
              labelId={`label_${CONST.activo.name}`}
              label={'Activar fecha'}
              onChange={(e) =>
                _handleSetDataField(CONST.activo.name, e.target.value)
              }
            >
              <MenuItem value={true}>SI</MenuItem>
              <MenuItem value={false}>NO</MenuItem>
            </Select>
            {dataError.activo && (
              <FormHelperText>{validMessage.required}</FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormBlopedFechas;
